module.exports = "/images/pierreLouis.png?fd96596197b86ac33066d0c0c6aff276";